// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"69":"devis-accept","320":"portail-client","884":"admin"}[chunkId] + "." + {"69":"dff8219d","320":"f74b2ab5","884":"18a5b62c"}[chunkId] + ".chunk.css";
};